import React, { useEffect, useRef, useState } from 'react';
import {
  ComponentParams,
  ComponentRendering,
  Placeholder,
} from '@sitecore-jss/sitecore-jss-nextjs';
import { isEditorActive } from '@sitecore-jss/sitecore-jss-nextjs/utils';

interface SectionProps {
  rendering: ComponentRendering & { params: ComponentParams };
  params: ComponentParams;
}
export const Default = (props: SectionProps): JSX.Element => {
  const sectionStyles = props.params && props.params.Styles ? props.params.Styles : '';
  const styles = `${sectionStyles}`.trimEnd();
  const phKey = `section-${props.params.DynamicPlaceholderId}`;
  const id = props.params.RenderingIdentifier;
  const [editingMode] = useState(isEditorActive());
  const [hasScrolled, setHasScrolled] = useState(false);

  const ref = useRef<HTMLDivElement>(null);
  const [showComponent, setShowComponent] = useState(false);
  useEffect(() => {
    if (!editingMode) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (ref.current) {
              observer.unobserve(ref.current);
              setShowComponent(true);
            }
          }
        });
      });
      if (ref.current) {
        observer.observe(ref.current);
      }
      return () => {
        if (ref.current) {
          observer.unobserve(ref.current);
        }
      };
    } else {
      setShowComponent(true);
      return () => {
        setShowComponent(false);
      };
    }
  }, [ref]);
  const handleScroll = () => {
    if (window.scrollY > 50)
      if (!hasScrolled) {
        setHasScrolled(true);
      }
  };
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);
  return (
    <>
      {styles.includes('contact-expert') ? (
        <section ref={ref} {...(styles ? { className: styles } : {})} id={id ? id : undefined}>
          {showComponent || hasScrolled ? (
            <Placeholder name={phKey} rendering={props.rendering} />
          ) : null}
        </section>
      ) : (
        <section {...(styles ? { className: styles } : {})} id={id ? id : undefined}>
          <Placeholder name={phKey} rendering={props.rendering} />
        </section>
      )}
    </>
  );
};
